// Money on screen (tanstack-router-structure-guide.md rule 25): pricing owns it, every other feature
// imports it. Rupiah grouped with dots, sen after a comma only when there are any. From dinero.js's
// decimal string, never through a JavaScript number.
import { hasSubUnits, toDecimal, transformScale, type Dinero } from "dinero.js";

/** "2.513.000", "100.000,50": the amount as an Indonesian reader writes it. */
export function formatAmount(amount: Dinero<number>): string {
  const decimal = toDecimal(transformScale(amount, 2));
  const [, sign = "", units = "0", sen = "00"] = /^(-?)(\d+)\.(\d{2})$/.exec(decimal) ?? [];
  const grouped = units.replace(/\B(?=(\d{3})+$)/g, ".");
  return `${sign}${grouped}${hasSubUnits(amount) ? `,${sen}` : ""}`;
}

/** "Rp 2.513.000". */
export const formatIDR = (amount: Dinero<number>) => `Rp ${formatAmount(amount)}`;
